var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "86074ADC-55C7-4D78-984A-1BD39DBFE8F1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sign-in-/-sign-up---3-Copy",
    transform: "translate(-617.000000, -357.000000)",
    fill: "#F6931E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(100.000000, 183.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15102",
    transform: "translate(0.000000, 122.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-exclamation-1081370",
    transform: "translate(517.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.52,15.72 C11.0400429,15.8400343 10.7999571,16.32 10.7999571,16.7999571 C10.7999571,17.3999571 11.2799143,17.9999571 11.9999571,17.9999571 C12.72,17.9999571 13.1999571,17.52 13.1999571,16.7999571 C13.1999571,15.8400429 12.2400429,15.3598714 11.52,15.72 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,6 C11.2799571,6 10.8,6.47995714 10.8,7.2 L10.8,13.2 C10.8,13.9200429 11.2799571,14.4 12,14.4 C12.7200429,14.4 13.2,13.9200429 13.2,13.2 L13.2,7.2 C13.2,6.47995714 12.7200429,6 12,6 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C5.4,0 0,5.4 0,12 C0,18.6 5.4,24 12,24 C18.6,24 24,18.6 24,12 C24,5.4 18.6,0 12,0 Z M12,21.6 C6.72,21.6 2.4,17.28 2.4,12 C2.4,6.72 6.72,2.4 12,2.4 C17.28,2.4 21.6,6.72 21.6,12 C21.6,17.28 17.28,21.6 12,21.6 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.62e3796a6735d11c3c11a3c5e2a7da47.svg";
export { ForwardRef as ReactComponent };